<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="options.width"
    @keydown.esc="cancel"
    v-bind:style="{zIndex: options.zIndex}"
  >
    <baseModal>

      <v-btn
        slot="positive-button"
        dark text class="orange--text text-h6 font-weight-bold" @click.native="agree">등록</v-btn>

      <v-btn
        v-if="index > -1"
        slot="func-button"
        dark text class="pink--text text--lighten-2 text-h6" @click.native="remove">삭제</v-btn>

      <v-btn
        slot="negative-button"
        dark text class="white--text subheading" @click.native="cancel">취소</v-btn>

      <v-toolbar-title
        slot="title-area"
        class="white--text">{{ title }}</v-toolbar-title>

      <v-card-text
        slot="content"
      >
        <v-container fluid class="pb-0">
          <v-form ref="form">
            <v-row
              align="center"
              justify="center"
              no-gutters
            >
              <v-col cols="12" xs="12">
                <v-text-field
                  v-model.trim="form.licenseName"
                  v-validate="'required|max:30'"
                  maxlength="30"
                  :error-messages="errors.collect('licenseName')"
                  data-vv-name="licenseName"
                  required
                  label="*면허|자격"
                  hint="전문분야등록증서-가족법"
                  class="pa-2"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12">
                <v-menu
                  ref="acqDateSelector"
                  v-model="acqDateSelector"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model.trim="form.acqDate"
                      label="취득일"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="form.acqDate"
                    locale="ko"
                    :active-picker.sync="activePicker"
                    :max="today"
                    min="1950-01-01"
                    @change="saveAcqDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" xs="12">
                <v-text-field
                  v-model.trim="form.publisher"
                  maxlength="30"
                  required
                  label="발행처"
                  hint="대한변호사협회"
                  class="pa-2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

    </baseModal>

  </v-dialog>
</template>

<script>
import baseModal from '@/components/common/BaseModal' // 기본 다이얼로그
import ko from 'vee-validate/dist/locale/ko'

export default {
  components: {
    baseModal
  },

  props: [ 'staffInfo' ],

  $_veeValidate: {
    validator: 'new'
  },

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    title: null,
    options: {
      color: 'primary',
      width: 500,
      zIndex: 200
    },
    // 참고: for Form
    form: {
      email: '',
      license: '', // 참고: 백엔드에 넘기기 위해 필요하다!
      type: 'license', // 참고: 백엔드에 타입 정보를 알린다
      licenseName: '',
      acqDate: '',
      publisher: ''
    },
    dictionary: {
      messages: ko.messages,
      attributes: {
        licenseName: '면허'
        // acqDate: '취득일',
        // publisher: '발행처'
      }
    },
    activePicker: null, // 생일셀렉터 date picker 의 타입결정인자
    acqDateSelector: false, // 참고: 취득일 셀렉터 메뉴
    index: -1, // 수정 인덱스
    today: ''
  }),

  watch: {
    acqDateSelector (val) { // 중요: 생일 셀렉터의 초기모드를 년선택으로 한다
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    }
  },

  created () {
    this.today = this.$moment().format('YYYY-MM-DD')
  },

  mounted () {
    this.$validator.localize('ko', this.dictionary)
  },

  methods: {
    dummy () {
    },
    sbpop (e) {
      // 서버에서 수신받은 에러는 router 에서 가로채기 하므로 띄우지 않도록 if (!e.response) 를 검사한다.
      if (!e.response) this.$store.commit('SB_POP', { msg: e.message })
    },
    // !!중요: 재귀적으로 부모의 $refs 를 탐색하여 target 객체를 찾아 리턴한다.
    // 주로 팝업을 검색하는데 사용!
    async findParentRefs (parent, target) {
      try {
        for (let key in parent.$refs) {
          if (key === target) { // 찾은경우
            return parent.$refs[key]
          }
        }
        // 못찾은 경우 - 부모가 또 있으면 올라간다.
        if (parent.$parent) {
          return await this.findParentRefs(parent.$parent, target)
        } else {
          return null // 못찾으면 null 리턴
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 초기화 함수
    initDialog () {
      // form validation 초기화
      this.$validator.reset()

      // 참고: staffInfo 변수중 이메일만 받는다
      this.form.email = this.staffInfo.email

      // 참고: 아래의 폼 변수는 따로 초기화 해야 한다.
      this.form.type = 'license'
      this.form.licenseName = ''
      this.form.acqDate = ''
      this.form.publisher = ''

      this.index = -1 // 참고: 수정용 인덱스 초기화
    },
    open (title, options, index = -1) {
      try {
        this.dialog = true
        this.title = title
        this.options = Object.assign(this.options, options)

        this.initDialog()

        // 참고: 편집 모드인 경우 - 넘어온 객체를 this.form 에 복사
        if (index > -1) {
          this.index = index
          this.form = Object.assign(this.form, this.staffInfo.license[index])
        }

        // 프로미스를 리턴하면서 resolve를 매칭하고있다.ddㅁㅁ
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 참고: 등록 버튼
    async agree () {
      try {
        if (!this.form.email) throw new Error('정상적인 데이터가 아닙니다.')

        // 참고: 입력값 검증
        let isValidate = await this.$validator.validateAll()
        if (!isValidate) throw new Error('입력값을 확인해 주세요')

        const { licenseName, acqDate, publisher } = this.form

        // 데이터가 정상이면 객체를 만들자
        const ioObject = { licenseName, acqDate, publisher }

        if (!this.staffInfo.license) {
          // 참고: 기존의 배열이 없으면.. 최초의 배열 생성
          const imsiArr = []
          imsiArr.push(ioObject)
          this.form.license = JSON.stringify(imsiArr)
          // 중요: 부모의 배열에 넣어줘야 함
          this.staffInfo.license.push(ioObject)
        } else {
          // 참고: 기존의 배열이 있으면 .. 편집과 등록에 따라 다르게 처리
          if (this.index > -1) {
            // 편집모드인 경우 해당 항목을 대치한다.
            const isChanged = await this.isChangedForm(ioObject)
            if (isChanged) {
              // 변경된게 있으면 업데이트 한다.
              this.staffInfo.license.splice(this.index, 1, ioObject)
            } else {
              // 변경이 없으면
              // throw new Error('변경된 내용이 없습니다.')
            }
          } else {
            // 등록 모드인 경우
            this.staffInfo.license.push(ioObject)
          }
          this.form.license = JSON.stringify(this.staffInfo.license)
        }

        const { data } = await this.$axios.post('admin/staff/editStaffProfile', this.form)
        if (!data.success) throw new Error(`오류가 발생하였습니다.: ${data.message}`)

        this.initDialog()

        this.resolve(true)
        this.dialog = false
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 취소 버튼
    cancel () {
      // 다이얼로그를 닫으면서 초기화 해야 한다!
      this.initDialog()
      this.resolve(false) // reject() 가 아니라 resolve(false)로 던져야 한다.
      this.dialog = false
    },
    // 참고: 삭제 버튼 - 수정모드에서만 발동됨
    async remove () {
      try {
        // !! 수정 모드가 아니면 에러
        if (!(this.index || this.index > -1)) throw new Error('삭제할 수 없습니다.')

        // 중요: 재귀적으로 부모의 $refs 에서 팝업 컴포넌트 객체를 얻는다.
        const target = 'confirmDialog'
        const pop = await this.findParentRefs(this.$parent, target)
        if (!pop) throw new Error('팝업창을 열 수 없습니다.')
        // 찾았으면 팝업을 연다
        const msg = `삭제 하시겠습니까? 삭제된 데이터는 복구할 수 없습니다.`
        if (await pop.open('삭제', msg, { color: 'error', width: 370 })) {
          // 삭제 - 이건 바로 부모창에도 적용된다.
          this.staffInfo.license.splice(this.index, 1)
          this.form.license = JSON.stringify(this.staffInfo.license)

          const { data } = await this.$axios.post('admin/staff/editStaffProfile', this.form)
          if (!data.success) throw new Error(`오류가 발생하였습니다.: ${data.message}`)

          this.resolve(true)
          this.dialog = false
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 참고: form 과 넘겨받은 staffInfo 중 달라진게 있는지 검사한다.
    async isChangedForm (v) {
      try {
        if (this.staffInfo.license[this.index].licenseName !== v.licenseName ||
          this.staffInfo.license[this.index].acqDate !== v.acqDate ||
          this.staffInfo.license[this.index].publisher !== v.publisher
        ) {
          return true
        } else {
          return false
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 참고: 취득일 셀렉트 선택시 저장 함수
    saveAcqDate (date) {
      this.$refs.acqDateSelector.save(date)
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
